import { render, staticRenderFns } from "./icone-presence.vue?vue&type=template&id=494b9d40&"
import script from "./icone-presence.vue?vue&type=script&lang=ts&"
export * from "./icone-presence.vue?vue&type=script&lang=ts&"
import style0 from "./icone-presence.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports